import { LoginPage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/login'].update({
        staticData: { title: { page: 'Pages.Login.Header', forWebinar: true } },
        component: LoginPage
    });
};
